<template>
    <customView-card-dialog
        :value="value"
        @input="$emit('input', $event)"
        :customView="customView"
        :loading="$wait.is('creatingCustomView')"
    >
        <template #activator="bindings">
            <slot v-bind="bindings"></slot>
        </template>
        <template #default="{ form, formId, isValid, loading, close }">
            <post-customView-button
                :value="form"
                :clear="() => {}"
                :valid="isValid"
                :form="formId"
                :loading="loading"
                v-wait-while="'creatingCustomView'"
                @http2xx="close().then(() => handleSuccessfulCreation($event))"
            >
            </post-customView-button>
        </template>
    </customView-card-dialog>
</template>

<i18n>
{
    "en": {
        "postCustomViewDialog.events.successfulCreation": "Successfully created the customView '{customViewName}'"
    }
}
</i18n>

<script>
import CustomViewCardDialog from '@/components/Domain.CustomViews/CustomViewCardDialog.vue';
import PostCustomViewButton from '@/components/Domain.CustomViews/PostCustomViewButton.vue';
import { toastSuccess } from '@/components/Common/Toast.vue';
export default {
    components: { CustomViewCardDialog, PostCustomViewButton },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        customView: {
            type: Object,
            default: null,
        },
    },
    methods: {
        handleSuccessfulCreation(form) {
            toastSuccess(this.$t('postCustomViewDialog.events.successfulCreation', { customViewName: form.name }));
            this.$emit('http2xx', form);
            this.$router.push(`/customViews/${form.id}`);
        },
    },
};
</script>